<template>
    <div id="detalle">
        <div class="banner">
            <h2>MANGO</h2>
        </div>
        <!-- <div class="flotante">
            <img src="@/assets/images/canasta.png" alt="">
        </div> -->
        <div class="inf">
            <div class="btns">
                <div id="btn1" class="btn active" @click="cambio('origen')">ORIGEN</div>
                <div id="btn2" class="btn" @click="cambio('variedades')">VARIEDADES</div>
                <div id="btn3" class="btn" @click="cambio('dis')">INFORMACION NUTRIMENTAL</div>
                <!-- <div id="btn4" class="btn" @click="cambio('prop')">PROPIEDADES</div>
                <div id="btn5" class="btn" @click="cambio('info')">INFORMACION NUTRIMENTAL</div> -->
            </div>
            <div id="bloques">
                <div id="origen">
                    <h2>Mango (Mangifera indica)</h2>
                    <p>
                      Este fruto carnoso, sabroso y refrescante, es el miembro más importante de la familia de
                      las Anacardiáceas o familia del marañón, género Mangifera, el cual comprende unas 50 especies,
                      nativas del sureste de Asia e islas circundantes, salvo la Mangifera africana que se encuentra en África.
                      Está reconocido en la actualidad como uno de los tres o cuatro frutos tropicales más finos.
                    </p>
                </div>
                <div id="variedades">
                   <p>
                     Es una fruta dulce, refrescante y de fácil consumo, rica en sustancias de acción antioxidante,
                     motivo por el cual su consumo es adecuado, teniendo en cuenta además sus propiedades nutritivas,
                     para toda la población: niños y jóvenes, adultos, deportistas, mujeres embarazadas o madres lactantes y personas mayores.
                   </p>
                   <p>
                     Por su aporte de provitamina A y vitamina C, se recomienda especialmente a quienes tienen un mayor riesgo de
                     sufrir carencias de dichas vitaminas: personas que no toleran los cítricos, el pimiento u otros vegetales,
                     que son fuente casi exclusiva de vitamina C en nuestra alimentación; para quienes deben llevar a cabo una
                     dieta baja en grasa y por tanto con un contenido escaso de vitamina A o para personas cuyas necesidades
                     nutritivas están aumentadas. Algunas de estas situaciones son: periodos de crecimiento,
                     embarazo y lactancia materna. Su contenido de fibra le confiere propiedades laxantes.
                     La fibra previene o mejora el estreñimiento, contribuye a reducir las tasas de colesterol en sangre,
                     al buen control de la glucemia y tiene un efecto saciante, beneficioso en caso de diabetes y exceso de peso,
                     eso sí, en cantidades adecuadas. Su contenido de potasio deberán tenerlo en cuenta las personas que padecen
                     de insuficiencia renal y que requieren de dietas controladas en este mineral. Sin embargo, quienes toman
                     diuréticos que eliminan potasio y padecen bulimia se beneficiarán de su consumo ya que en el mango abunda
                     dicho mineral.
                   </p>
                </div>
                <div id="disponibilidad">
                    <img src="@/assets/images/tablaMango.jpg" alt="">
                </div>
                <div id="propiedades">
                    <p>Este fruto, en el hemisferio norte, es de verano. Fuera de temporada puede adquirirse en conserva.
                       Cuando se compran cerezas dulces frescas, se debe elegir aquellas que sean pesadas y de color rojo oscuro o negro.
                       En el caso de las cerezas ácidas el color a seleccionar es el rojo claro o el rosado amarillendo.
                       En Ambos casos el tallo estará bien unido a la cereza.
                    </p>
                    <p>
                        Todas las variedades de cereza proporcionan provitamina A y vitamina C, fibra, potasio y flavonoides.
                        Una ración de 140 g de cerezas dulces suministra aproximadamente un 2% de la ingesta diaria recomendada de vitamina A y un 15% de vitamina C.
                        Las cerezas son pobres en grasa, aunque no contiene grasas saturadas, sodio, colesterol, de modo que ofrecen un tentempié bajo en calorías.
                        La vitamina A es esencial para la vista, el crecimiento, el desarrollo de los huesos, el mantenimiento de los tejidos corporales,
                        la reproduccion y el desarrollo de las funciones hormnonales y de las co-enzimas. La vitamina C es un poderoso antioxidante,
                        de modo que puede proteger contra diversos tipos de cancér, a la vez que intensifica las funciones inmunológicas.
                        Investigaciones muestran que consumir fibra ayuda a proteger contra un número de transtornos del tubo digestivo incluyendo el cancér de intestino.
                        Los flavonoides se consideran entre muchos de los componentes menores que, en una dieta variada, pueden proteger contra el cáncer y otras enfermedades cardiovasculares.
                        Dietas bajas en sodio pueden reducir el riesgo derivado de una presión sanguínea alta, cuyo desarrollo depende de otros muchos factores.
                    </p>
                </div>
                <div id="info-nut">

                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
  data() {
    return {

    };
  },
  methods: {
    cambio(active) {
      const btn1 = document.getElementById('btn1');


      const btn2 = document.getElementById('btn2');


      const btn3 = document.getElementById('btn3');

      // btn4 = document.getElementById('btn4'),
      // btn5 = document.getElementById('btn5'),

      const origen = document.getElementById('origen');


      const variedades = document.getElementById('variedades');


      const disponibilidad = document.getElementById('disponibilidad');
      // propiedades = document.getElementById('propiedades'),
      // inf = document.getElementById('info-nut');


      origen.style.display = 'none';
      variedades.style.display = 'none';
      disponibilidad.style.display = 'none';
      //  propiedades.style.display='none';
      //  inf.style.display='none';

      btn1.className = 'btn';
      btn2.className = 'btn';
      btn3.className = 'btn';
      //  btn4.className='btn';
      //  btn5.className='btn';

      if (active == 'origen') {
        console.log('origen');
        btn1.classList.add('active');
        origen.style.display = 'block';
      } else if (active == 'variedades') {
        console.log('var');
        btn2.classList.add('active');
        variedades.style.display = 'block';
      } else if (active == 'dis') {
        console.log('dis');
        btn3.classList.add('active');
        disponibilidad.style.display = 'block';
      } // else if(active == 'prop'){
      //   console.log('props');
      //   btn4.classList.add('active');
      //   propiedades.style.display='block';
      // }else{
      //   console.log('info');
      //   btn5.classList.add('active');
      //   inf.style.display='block';
      // }
    },
  },
};
</script>

<style lang="scss" scoped>
#detalle {
  .active {
    background: gray !important;
    display: block;
  }
  .banner {
      height: 50vh;
      background-image: url('../../assets/images/grid/11.jpg');
      background-position: center;
      background-repeat: no-repeat;
      background-size: cover;
      display: flex;
      justify-content: center;
      align-items: flex-start;

      h2 {
          position: relative;
          top: 10%;
          color: #fff;
          font-size: 2.2em;
          font-weight: bold;
      }
  }
  .flotante {
      position: relative;
      top: -30vh;;
      z-index: 10;

  }
  .inf {
      // position: relative;
      // top: -30vh;
      .btns {
          margin: 2% auto;
          margin-bottom: 4%;
          display: flex;
          flex-wrap: wrap;
          justify-content: center;
          .btn {
            cursor: pointer;
              width: 200px;
              height: 50px;
              display: flex;
              align-items: center;
              justify-content: center;
              margin: 5px 15px;
              color: #fff;
              background-color: green;
              border-radius: 10px;
              padding: 10px 30px;
          }
          .btn:nth-child(5) {
              width: 300px;
          }
      }
      #bloques {
          text-align: justify;

        > div {
            color: gray;
           font-size: 1.3em;
            margin: 0 20%;
            h2 {
              text-align: center;
            }
        }
        #origen {
          display: block;

          h2 {
            text-align: center;
          }
        }
        #variedades {
            display: none;
        }
        #disponibilidad {
            display: none;
        }
        #propiedades {
            display: none;
        }
        #info-nut {
            display: none;
        }
      }
  }
}
</style>
